import React from 'react';

/**
 * Testimonials component showcases feedback from clients who have partnered
 * with Aakeeo. Three cards display quotes and the names of the clients.
 * This section can later be expanded into a carousel if desired.
 */
const Testimonials = () => {
  return (
    <section id="testimonials" className="section testimonials reveal">
      <div className="section-header">
        <h2>What our Clients Say about US</h2>
        <p>Don’t just take our word for it—hear directly from the businesses we’ve helped transform.</p>
      </div>
      <div className="testimonials-staggered">
        <div className="testimonial-card testimonial-card-1">
          <p className="testimonial-text">"Aakeeo is an amazing team of SuiteCRM developers/professional. They are expert at what they do, they went beyond their duty and delivered so much extra. Very generous with their time and super responsive."</p>
          <p className="testimonial-author">Mustafa — Vocal Legal, UK</p>
        </div>
        <div className="testimonial-card testimonial-card-2">
          <p className="testimonial-text">"Aakeeo was a pleasure to work with. Very professional and provided solutions to our requirements. Would recommend Aakeeo on any Suite/Sugar CRM project"</p>
          <p className="testimonial-author">Brendon Bell — Edu Camp, Australia</p>
        </div>
        <div className="testimonial-card testimonial-card-3">
          <p className="testimonial-text">"Great work with Aakeeo, they not only delivered a very fine quality job on time but was also very helpful, pedagogical and constructive in the design of the solution."</p>
          <p className="testimonial-author">Thomas — Fregat.io, France</p>
        </div>
        <div className="testimonial-card testimonial-card-4">
          <p className="testimonial-text">"Working with Arun on our SuiteCRM implementation was a seamless and highly productive experience. His deep expertise, proactive approach, and commitment to understanding our needs made the transition smooth and efficient. From customization to troubleshooting, he ensured that our CRM was tailored perfectly to our business requirements. I highly recommend his services to anyone looking for a reliable and knowledgeable CRM expert"</p>
          <p className="testimonial-author">Benktesh Sharma — Verra.org</p>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;